import React from 'react';
import { graphql } from 'gatsby';
import Layout from '@components/Layout';
import Filters from '@components/shared/Filters';
import IconTextGrid from '@components/shared/IconTextGrid';
import ProductCatalogue from '@components/storefront/ProductCatalogue';
import { getUSPData } from '@components/storefront/productsUSPsData';
import { getShopProducts } from '@data/storefront';
import { useCountry } from '@hooks/useCountry';
import { filterProducts, applyCountrySpecificSorting } from '@utils/product';

export const query = graphql`
  query ($language: String!, $id: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    prismicEcommerceProductCategory(id: { eq: $id }) {
      uid
      data {
        title
        meta_title
        meta_description
      }
    }
    allPrismicEcommerceProductCategory(sort: { data: { category_nav_order: ASC } }) {
      nodes {
        data {
          title
        }
        uid
        lang
      }
    }
  }
`;

const Products = ({ data }) => {
  const { nodes } = data.allPrismicEcommerceProductCategory;
  const {
    uid,
    data: { title, meta_title, meta_description }
  } = data.prismicEcommerceProductCategory;
  const { country } = useCountry();
  const shopProducts = getShopProducts();
  const filteredProducts = filterProducts(country, shopProducts);
  const products = applyCountrySpecificSorting(country, filteredProducts);
  const categoryProducts = products.filter((item) => {
    const itemCategories =
      item.product_categories && item.product_categories.text !== '' ? item.product_categories.text?.split(',') : [item.product_category.uid];
    return itemCategories?.includes(uid);
  });

  const SEO = {
    uid,
    href: `/products/${uid}/`,
    title: meta_title || title,
    description: meta_description || ''
  };

  return (
    <Layout SEO={SEO}>
      <Filters products={products} categories={nodes} />
      <ProductCatalogue data={categoryProducts} />
      <IconTextGrid slice={getUSPData()} />
    </Layout>
  );
};

export default Products;
